import templateUrl from './number.tpl.html';

angular
    .module('festzelt-os.components')
    .component('filterNumber', {
        bindings: {
            store: '<',
            col: '<',
        },
        controllerAs: 'vm',
        templateUrl: templateUrl,
    });



// WEBPACK FOOTER //
// ./src/app/components/state-manager/filter-field/types/filter-type-number.js